import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";

import StocksReportsScreen from "../../../screens/Reports/StocksReportScreens/StocksReportScreen";
import PrdouctsReportsScreen from "../../../screens/Reports/ProductsReportScreens/ProductsReportScreen";
import ProductionStocksReportScreen from "../../../screens/Reports/ProductionStocksReportScreen";
import RawMaterialStocksReportScreen from "../../../screens/Reports/RawMaterialReportScreens/RawMaterialStocksReportScreen";
import RawMaterialStocksOverviewReportScreen from "../../../screens/Reports/RawMaterialReportScreens/RawMaterialStocksOverviewReportScreen";
import CustomerStatusReportsScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusReportScreen";
import PmxInventoryReportScreen from "../../../screens/Reports/PmxReportScreens/PmxInventoryReportScreen";
import PmxDetailsInventoryReportScreen from "../../../screens/Reports/PmxReportScreens/PmxDetailsInventoryReportScreen";
import { drawerItemsMain } from "./ReportsDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import { useEffect, useState } from "react";
import { userClaimInformation } from "../../../models/usersModel";
import { useSelector } from "react-redux";
import teamConfig from "../../../utils/constants/teams";

import DynamicWidthScreen from "../../../screens/NotUsed/DynamicWidthScreen";
import StockReportDetailsReportScreen from "../../../screens/Reports/StocksReportScreens/StockReportDetailsReport";
import ProductionStockDetailsReportScreen from "../../../screens/Reports/ProductionStockDetailsReportScreen";
import PmxInventoryDetailsReportScreen from "../../../screens/Reports/PmxReportScreens/PmxInventoryDetailsReportScreen";
import PmxDetailsInventoryDetailReportScreen from "../../../screens/Reports/PmxReportScreens/PmxDetailsInventoryDetailReportScreen";
import CustomerStatusDetailReportScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusDetailReportScreen";

const Drawer = createDrawerNavigator();

export default function ReportsDrawerNavigator() {
  const dimensions = useWindowDimensions();
  const [userProfile, setUserProfile] = useState<userClaimInformation>();
  const { userInfo } = useSelector((state: any) => state.configurations);

  const { warehouse } = teamConfig.teams;

  useEffect(() => {
    setUserProfile(userInfo);
  }, [userInfo]);

  return (
    <Drawer.Navigator
      initialRouteName="Home"
      screenOptions={{
        drawerStyle: {
          width: 180,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent
          drawerItems={drawerItemsMain(userProfile?.team.toUpperCase())}
          {...props}
        />
      )}
    >
      <Drawer.Screen
        name="Stocks"
        component={StocksReportsScreen}
        options={{ title: "Stock" }}
      />
      {userProfile?.team.toUpperCase() !== warehouse && (
        <>
          <Drawer.Screen
            name="ProductionStocks"
            component={ProductionStocksReportScreen}
            options={{ title: "Production Stock" }}
          />
          <Drawer.Screen
            name="ProductionStockDetailsReportScreen"
            component={ProductionStockDetailsReportScreen}
            options={{ title: "Production Stock Details" }}
          />
          <Drawer.Screen
            name="RawMaterialStocksOverView"
            component={RawMaterialStocksOverviewReportScreen}
            options={{ title: "Raw Material Overview" }}
          />
          <Drawer.Screen
            name="RawMaterialStocksDetails"
            component={RawMaterialStocksReportScreen}
            options={{ title: "Raw Material Stock" }}
          />
        </>
      )}
      <Drawer.Screen
        name="WarehouseInventory"
        component={PmxInventoryReportScreen}
        options={{ title: "Inventory Overview" }}
      />
      <Drawer.Screen
        name="PmxInventoryDetailsReportScreen"
        component={PmxInventoryDetailsReportScreen}
        options={{ title: "Inventory Overview Details" }}
      />
      <Drawer.Screen
        name="WarehouseDetailsInventory"
        component={PmxDetailsInventoryReportScreen}
        options={{ title: "Inventory Detail" }}
      />
      <Drawer.Screen
        name="PmxDetailsInventoryDetailReportScreen"
        component={PmxDetailsInventoryDetailReportScreen}
        options={{ title: "Inventory Detail Report" }}
      />
      {userProfile?.team.toUpperCase() !== warehouse && (
        <Drawer.Screen
          name="Products"
          component={PrdouctsReportsScreen}
          options={{ title: "Search Product" }}
        />
      )}
      <Drawer.Screen
        name="CustomerStatus"
        component={CustomerStatusReportsScreen}
        options={{ title: "Customer Status" }}
      />
      <Drawer.Screen
        name="CustomerStatusDetailReportScreen"
        component={CustomerStatusDetailReportScreen}
        options={{ title: "Customer Status Details" }}
      />
      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          name="DynamicWidth"
          component={DynamicWidthScreen}
          options={{ title: "Dynamic Width" }}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: "StockReportDetailsReportScreen",
          title: "Stock Report Details",
        }}
        name="StockReportDetailsReportScreen"
        component={StockReportDetailsReportScreen}
      />
    </Drawer.Navigator>
  );
}
